<template>
    <div
		class="modal fade"
		:class="name"
		ref="modal"
		tabindex="-1"
		role="dialog"
		:aria-labelledby="name+'label'"
		aria-hidden="true">
	  	<div class="modal-dialog">
	    	<div class="modal-content">
	     		<div class="modal-header">
			        <h5 class="modal-title" :id="name+'label'">Notificações</h5>
				    <button
				    	type="button"
				    	class="close"
				    	data-dismiss="modal"
				    	aria-label="Fechar"
				    	:id="name">
				    	<span aria-hidden="true">&times;</span>
				    </button>
			    </div>
			    <div class="modal-body" :class="{ modalRoll: notificationsTotal > 2}">
                    <div
                        class="card mb-3 pointer-click"
                        :class="notification.data.class"
                        v-for="notification in unreadNotifications"
                        @click="acessarNotification(notification)">
                        <div class="card-body">
                            <span>
                                <small>{{ formatDate(notification.created_at) }}</small>
                            </span>
                            <h5 class="card-title">{{ notification.data.title }}</h5>
                            <p class="card-text">
                                {{ notification.data.description }}
                            </p>
                            <a href="#" class="btn btn-primary" v-if="notification.data.url">Clique para acessar</a>
                        </div>
                    </div>
                    <div v-if="readNotifications.length > 0 && !unreadNotifications">
                        <h5 class="card-title">Você não tem novas notificações</h5>
                    </div>
                    <div v-if="readNotifications.length > 0 && unreadNotifications.length > 0">
                        <hr>
                    </div>
                    <div v-if="readNotifications.length > 0">
                        <h5 class="card-title">Anteriores</h5>
                        <div
                            class="card mb-3 pointer-click"
                            @click="acessarNotification(notification)"
                            v-for="notification of readNotifications">
                            <div class="card-body">
                                <span>
                                    <small>{{ formatDate(notification.created_at) }}</small>
                                </span>
                                <h5 class="card-title">{{ notification.data.title }}</h5>
                                <p class="card-text">
                                    {{ notification.data.description }}
                                </p>
                                <a href="#" class="btn btn-primary" v-if="notification.data.url">Clique para acessar</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="readNotifications.length == 0 && unreadNotifications.length == 0">
                        <h5 class="card-title">Você não tem notificações</h5>
                    </div>
			    </div>
	    	</div>
	  	</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				unreadNotifications: [],
                readNotifications: [],
				name: 'notification_modal',
                notificationsTotal: 0
			}
		},
        created(){
            let self = this;
            self.getNotifications();
            self.getNotificationsReaded()
            EventBus.$on('create-clausula', function (){
                $(self.$refs.modal).modal('show');
            });
        },
		methods: {
			getNotifications(){
                axios.get(this.$url+'/api/adm/notifications/unreadNotifications')
	            .then(response => {
	            	this.unreadNotifications = response.data
                    this.notificationsTotal += this.unreadNotifications.length
	            })
	            .catch(error => {
	            	console.log(error)
	            });
        	},
            getNotificationsReaded(){
                axios.get(this.$url+'/api/adm/notifications/readNotifications')
	            .then(response => {
	            	this.readNotifications = response.data
                    this.notificationsTotal += this.readNotifications.length
                    console.log(this.notificationsTotal)
	            })
	            .catch(error => {
	            	console.log(error)
	            });
        	},
            acessarNotification(notification){
                if(notification.data.url){
                    this.$router.push({path: '/adm'})
                    let self = this;
                    setTimeout(() => {  self.$router.push(notification.data.url) }, 100);
                    $(this.$refs.modal).modal('hide');
                }
            },
            formatDate(data){
                let date = new Date(data);
                let year = date.getFullYear();
                let month = date.getMonth()+1;
                let hour = String(date.getHours());
                let minute = String(date.getMinutes());
                let second = String(date.getSeconds());
                let dt = date.getDate();
                if (dt < 10) {
                    dt = '0' + dt;
                }
                if (month < 10) {
                    month = '0' + month;
                }
                if(hour.length < 2){
                    hour = '0' + hour;
                }
                if(minute.length < 2){
                    minute = '0' + minute;
                }
                if(second.length < 2){
                    second = '0' + second;
                }

                return dt+'/'+month+'/'+year+' '+hour+':'+minute+':'+second;
            }
		},
	}
</script>

<style scoped>
    .modal-dialog{
        overflow-y: initial !important
    }
    .modal-body{
        overflow-y: auto;
    }
    .modalRoll {
        height: 80vh;
    }
    .pointer-click {
        cursor: pointer;
    }
</style>
